import {
  FURUI_FRUI_QPGOODS_MODAL_CHANGE,
} from './constants';

export function frui_qpgoodsModalChange(visible,type) {
  return {
    type: FURUI_FRUI_QPGOODS_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FURUI_FRUI_QPGOODS_MODAL_CHANGE:
      return {
        ...state,
        frui_qpgoodsModalType:action.data.type,
        frui_qpgoodsModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/furui/redux/frui_qpgoodsModalChange.js